import React, { Fragment } from 'react';
import Carousel from 'react-multi-carousel';
import Skeleton from './MiniCarouselSkeleton';
import SimpleCoverageCards from './SimpleCoverageCards';

const SimpleCoverageCarousel = ({
  memberAccumulatedData,
  activeMember,
  activeMemberIndex,
  defaultNetworkForAll,
  skeletonLoader,
}) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 0 },
      items: 1,
    },
  };

  let displayCards = [];
  let lists = [];
  const chunkSize = 4;
  if (memberAccumulatedData && memberAccumulatedData.length) {
    displayCards = memberAccumulatedData.map((item) => {
      if (
        item?.Product === 'Medical' ||
        item?.Product === 'Dental' ||
        item?.Product === 'Prescription' ||
        item?.Product === 'Vision'
      ) {
        return {
          benefitPlan: item.BenefitPlan,
          product: item.Product,
          activeMemberIndex: 1,
        };
      }
    });
    displayCards = displayCards.filter((f) => f !== undefined);
    lists = [...Array(Math.ceil(displayCards.length / chunkSize))].map((_) =>
      displayCards.splice(0, chunkSize),
    );
  }

  return (
    <div className="carousel-container p-0">
      <div className="carousel-wrapper">
        {/*<Carousel
          additionalTransfrom={0}
          arrows
          autoPlaySpeed={3000}
          centerMode={false}
          className=""
          containerClass="container-with-dots"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite={false}
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          itemClass="slider-image-item"
          responsive={responsive}
        > */}

        {skeletonLoader
          ? [1].map((item, index) => (
              <Fragment key={index}>
                <Skeleton />
              </Fragment>
            ))
          : lists.map((list, index) => (
              <Fragment key={index}>
                <SimpleCoverageCards
                  list={list}
                  activeMember={activeMember}
                  activeMemberIndex={activeMemberIndex}
                  defaultNetworkForAll={defaultNetworkForAll}
                />
              </Fragment>
            ))}
        {/*</Carousel> */}
      </div>
    </div>
  );
};
export default SimpleCoverageCarousel;
